import './ga4';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

window.addEventListener('load', function () {
    //
    // fermeture du offcanvas au resize si on dépasse le breakpoint lg
    //
    const menuElement = document.getElementById('menu');
    
    if (menuElement) {
        const menuOffcanvas = Offcanvas.getOrCreateInstance(menuElement);
        const lgBreakpoint = 984;

        window.addEventListener('resize', () => {
            if (window.innerWidth >= lgBreakpoint && menuElement.classList.contains('show')) {
                menuOffcanvas.hide();
            }
        });
    }
});